import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Paper,
  Radio,
  Select,
  Tab,
  Tabs,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import BlockIcon from "@material-ui/icons/Block";
import CheckIcon from "@material-ui/icons/Check";
import PrintIcon from "@material-ui/icons/Print";
import { DatePicker } from "@material-ui/pickers";
import clsx from "clsx";
import { ALERT_TYPE } from "components/common/Alert";
import withLayout from "components/HoC/withLayout";
import { UploadButton } from "components/request-document/components/Commons";
import { format } from "date-fns";
import { useFormik } from "formik";
import { STATUS_PROCESS, VISA_TYPE_NAME } from "libs/configs/constant";
import useAdminModalLoading from "libs/hooks/useAdminModalLoading";
import useAlert from "libs/hooks/useAlert";
import useModalLoading from "libs/hooks/useModalLoading";
import { openFileById } from "libs/utils/file";
import { getErrorMessage } from "libs/utils/form";
import HttpClient from "libs/utils/HttpClient";
import { get, isError } from "lodash";
import mime from "mime";
import PropTypes from "prop-types";
import queryString from "query-string";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import AllDocumentsService from "services/AllDocumentsService";
import AppointmentService from "services/AppointmentService";
import FileService from "services/FileService";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import * as yup from "yup";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: 0,
    paddingBottom: 124,
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  userName: {
    fontSize: "1.25rem",
    fontWeight: "600",
    fontFamily: "system-ui",
    color: "#4A5C6A",
  },
  wrapDocDetail: {
    marginTop: 30,
  },
  appTitle: {
    color: "rgba(0,0,0,0.54)",
    fontSize: "13px",
    marginTop: 30,
  },
  appValue: {
    display: "flex",
    alignItems: "center",
    marginTop: 15,
  },
  appValue1: {
    color: "#8898AA",
    fontWeight: "500",
    fontSize: "15px",
  },
  appValue2: {
    color: "#2196F3",
    fontSize: "18px",
    fontFamily: "system-ui",
    fontWeight: "500",
    paddingTop: "10px",
  },
  appValue3: {
    alignItems: "center",
    display: "flex",
  },
  tabAppointment: {
    marginTop: "36px",
    fontSize: "14px",
    borderBottom: "1px solid whitesmoke",
    paddingBottom: "8px",
  },
  flexMiddle: {
    display: "flex",
    alignItems: "center",
  },
  appointmentText: {
    color: "#003668",
    fontSize: "14px",
    display: "inline-block",
    fontWeight: "400",
    marginRight: "15px",
  },
  appointmentDate: {
    backgroundColor: "#E3F2FD",
    padding: "7px 10px",
    display: "inline-block",
    color: "#2196F3",
    fontWeight: "bold",
    fontSize: "14px",
  },
  appointmentDate2: {
    backgroundColor: "#11CDEF",
    padding: "7px 10px",
    display: "inline-block",
    color: "white",
    fontWeight: "500",
    fontSize: "14px",
  },
  wrapAppointmentDate: {
    display: "flex",
    alignItems: "center",
  },
  wrapContoller: {
    marginTop: 30,
  },
  textDialog: {
    width: "100%",
  },
  rowInput: {
    marginTop: 10,
  },
  warpButtonDialogSave: {
    display: "flex",
  },
  buttonDialogSave: {
    width: "100%",
    margin: "15px 5px",
  },
  sigImage: {
    backgroundSize: "200px 50px",
    height: "200px",
    width: "100%",
    backgroundColor: "white",
    borderRadius: 15,
  },
  middle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  wrapNoFile: {
    position: "absolute",
    width: "100%",
    height: "100%",
    top: "0",
    left: "0",
    zIndex: "11",
    backgroundColor: "rgba(237, 28, 36, 0.2)",
    border: "2px solid #ED1C24",
  },
  nofile: {
    backgroundColor: "rgba(237, 28, 36, 0.2)",
    border: "2px solid #ED1C24",
  },
  requiredDoc: {
    textAlign: "center",
    color: "#ED1C24",
    fontSize: "13px",
    fontWeight: "500",
    marginTop: "10px",
  },
}));

function AppointmentTab() {
  const classes = useStyles();
  const [appDate, setAppDate] = useState(new Date());
  const [Timeapp, setTimeApp] = useState([]);
  const [appTimeCf, setApptimeCf] = useState(null);
  const [timeText, setTimetext] = useState([]);
  const [visaMinDate, setVisaMinDate] = useState(null);
  const [visaMaxDate, setVisaMaxDate] = useState(null);
  const [visaValidDetail, setVisaValidDetail] = useState(null);
  const [visaDate, setVisaDate] = useState(new Date());
  const [stampDetail, setStampDetail] = useState(null);
  const [docDetail, setDocDetail] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [messageDialog, setMessageDialog] = useState("");
  const [personalO, setPersonalO] = useState([]);
  const [StampDetailpersonalO, setStampDetailPersonalO] = useState([]);

  const { showAlert, hideAlert } = useAlert();
  const [signDataUri, setSignDataUri] = useState(null);
  const [imageDataUri, setImageDataUri] = useState("");
  const params = useParams();
  const { showLoading, hideLoading } = useModalLoading();
  const draftId = get(params, "draftId", "") || "";
  const { showAdminLoading, hideAdminLoading } = useAdminModalLoading();
  const { search } = useLocation();
  const queryParams = queryString.parse(search);

  const [value, setValue] = React.useState(
    queryParams?.stamped === "1" ? 1 : 0
  );

  const [openDocUpload, setOpenDocUpload] = React.useState(false);
  const masterData = useSelector(selectMasterData);
  const validationSchema = yup.object({
    // empId: yup.string().required("Employee is required.")
    // startDate: yup.date().required("Date is required."),
    // remark: yup.string().required("Holiday name is required."),
  });
  const dispatch = useDispatch();
  const countryConfig = get(masterData, "countryConfig", []);
  const countryEmbassy = get(masterData, "countryEmbassy", []);
  const theImmigrationBureauConfig = get(
    masterData,
    "theImmigrationBureauConfig",
    []
  );
  const isOversea = docDetail?.visaissurance?.overseas;
  const minDate = new Date(docDetail?.preApproveDate);
  const maxDate = new Date(docDetail?.preApproveDate);
  maxDate.setDate(maxDate.getDate() + 60);

  // const minVisaDate = new Date(docDetail?.preApproveDate);
  // const maxVisaDate = new Date(docDetail?.preApproveDate);
  // maxVisaDate.setDate(maxVisaDate.getDate() + 15);

  let formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      overseas: isOversea,
      thailand: !isOversea,
      theImmigrationBureauID:
        docDetail?.visaissurance?.theImmigrationBureauID || "",
      countryId: docDetail?.visaissurance?.countryId,
      cityId: docDetail?.visaissurance?.cityId,
    },
    onSubmit: async (c) => {
      console.log(c);
    },
  });

  // useEffect(async () => {
  //   if (!countryConfig ) {
  //     await dispatch(
  //       getMasterData({
  //         CountryConfig: true,
  //         theImmigrationBureauConfig: true,
  //       })
  //     );
  //   }

  // }, [dispatch]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(async () => {
    await getAppointment();
    await getVisaValid();

    await dispatch(
      getMasterData({
        countryEmbassy: true,
        theImmigrationBureauConfig: true,
      })
    );

    if (
      queryParams?.stamped === "1" &&
      stampDetail?.stampStatus == "C" &&
      !stampDetail?.stampFileId
    ) {
      setOpenDocUpload(true);
    }

    //Set Time Appointment
    let newDate = format(new Date(), "yyyy/MM/dd");

    try {
      const response = await HttpClient.get(
        `/api/stamp/time/list?StampDate=${newDate}`
      );

      setTimeApp(response.results);

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }, []);

  // useEffect(async () => {
  //   if (docDetail) {
  //     const _isOversea = docDetail?.visaissurance?.overseas;
  //     formik.setFieldValue('overseas', _isOversea)
  //     formik.setFieldValue('thailand', !_isOversea)
  //     formik.setFieldValue('theImmigrationBureauID', docDetail?.visaissurance?.theImmigrationBureauID)
  //     formik.setFieldValue('countryId', docDetail?.visaissurance?.countryId)
  //     formik.setFieldValue('cityId', docDetail?.visaissurance?.cityId)
  //   }
  // }, [countryConfig, theImmigrationBureauConfig])

  useEffect(async () => {
    if (docDetail?.personalId) {
      await getPersonalO(docDetail?.personalId);
      await getStampDetailPersonalO(docDetail?.personalId);
    }
  }, [docDetail]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(async () => {
    if (stampDetail) {
      if (
        queryParams?.stamped === "1" &&
        stampDetail?.stampStatus == "C" &&
        !stampDetail?.stampFileId
      ) {
        setOpenDocUpload(true);
      }
    }
  }, [stampDetail]);

  const getVisaValid = async () => {
    const res = await AllDocumentsService.getVisaValid({ draftId: draftId });

    if (res.status && res.results) {
      setVisaMinDate(new Date(res.results?.visaMinDate));
      setVisaMaxDate(new Date(res.results?.visaMaxDate));

      setVisaValidDetail(res.results);
    }
  };

  const getPersonalO = async (params) => {
    const res = await AllDocumentsService.getPersonalSO({
      params,
    });
    if (res.status && res.results) {
      setPersonalO(res.results);
    }
  };

  const getStampDetailPersonalO = async (params) => {
    const res = await AllDocumentsService.getStampDetailPersonalSO({
      params,
    });
    if (res.status && res.results) {
      setStampDetailPersonalO(res.results);
    }
  };

  const getAppointment = async () => {
    const resDoc = await AllDocumentsService.getAllDocuments({
      draftId: draftId,
    });

    if (resDoc.status && resDoc.results?.length > 0) {
      setDocDetail(resDoc.results[0]);
    }
    const res = await AppointmentService.getAppointments({ draftId: draftId });

    if (res.status && res.results?.length > 0) {
      const detail = res.results[0];

      setStampDetail(detail);

      // await PersonalO(stampDetail?.personalId);
      setEditMode(false);

      // End Settime
      if (detail.userProfileFileId) {
        const data = await FileService.getFile(detail.userProfileFileId);
        try {
          const fileName =
            detail.userProfileFileName + detail.userProfileFileExt;
          const blobFile = new File([data], fileName, {
            type: mime.getType(detail.userProfileFileExt),
          });

          setImageDataUri(URL.createObjectURL(blobFile));
        } catch (error) {
          console.error(error);
        }
      }
      if (detail.userSignedFileId) {
        const data = await FileService.getFile(detail.userSignedFileId);
        try {
          const fileName = detail.userSignedFileName + detail.userSignedFileExt;
          const blobFile = new File([data], fileName, {
            type: mime.getType(detail.userSignedFileExt),
          });

          setSignDataUri(URL.createObjectURL(blobFile));
        } catch (error) {
          console.error(error);
        }
      }
      //Set Time Appointment
      let newDate = format(new Date(detail.stampDate), "yyyy/MM/dd");

      try {
        const response = await HttpClient.get(
          `/api/stamp/time/list?StampDate=${newDate}`
        );

        setTimeApp(response.results);

        setApptimeCf(detail?.stampTimeID);
        const TimeText = response.results.find((e) => {
          return (e.stampTimeID = detail?.stampTimeID);
        });
        // console.log(TimeText);
        setTimetext(TimeText);

        if (response.status) return response;
        return Promise.reject(response);
      } catch (error) {
        const newError = error;
        throw newError;
      }
    } else {
      setStampDetail(null);
      setEditMode(true);
    }
  };

  const submitCancel = async (personalId) => {
    const data = {
      personalID: personalId,
    };
    try {
      const response = await HttpClient.post("/api/agency/cancel", data);

      if (response.status) {
        setMessageDialog(response.message);
        setOpen(true);
      } else {
        setMessageDialog(response.message);
        setOpen(true);
      }
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  const handleOnStampDate = async () => {
    if (!window.confirm("Do you want to stamp this date?")) {
      return;
    }
    showLoading();

    try {
      const body = {
        draftId: draftId,
        stampDate: format(new Date(appDate), "yyyy-MM-dd"),
        status: true,
        overseas: formik.values.overseas ? formik.values.overseas : false,
        countryId: formik.values.overseas ? formik.values.countryId : null,
        cityId: formik.values.overseas ? formik.values.cityId : null,
        thailand: formik.values.thailand ? formik.values.thailand : false,
        theImmigrationBureauID: formik.values.theImmigrationBureauID,
        visaInssuanceId: docDetail?.visaissurance?.visaInssuanceId,
        draftIdMain: draftId,
        stampTimeID: appTimeCf,
      };
      const bodyVisa = {
        draftId: draftId,
        visaValidDate: format(new Date(visaDate), "yyyy-MM-dd"),
      };

      const bodyCheckAgency = {
        draftId: draftId,
      };

      const res = await AppointmentService.stampAppointment(body);
      const resVisa = await AppointmentService.updateVisaDate(bodyVisa);
      const resCheck = await AppointmentService.stampAgencyCheckAppointment(
        bodyCheckAgency
      );

      personalO.forEach(async (x) => {
        const _body = {
          draftId: x?.draftId,
          stampDate: format(new Date(appDate), "yyyy-MM-dd"),
          status: true,
          overseas: formik.values.overseas ? formik.values.overseas : false,
          countryId: formik.values.overseas ? formik.values.countryId : null,
          cityId: formik.values.overseas ? formik.values.cityId : null,
          thailand: formik.values.thailand ? formik.values.thailand : false,
          theImmigrationBureauID: formik.values.theImmigrationBureauID,
          visaInssuanceId: docDetail?.visaissurance?.visaInssuanceId,
          draftIdMain: draftId,
          stampTimeID: appTimeCf,
        };
        const _bodyVisa = {
          draftId: x?.draftId,
          visaValidDate: format(new Date(visaDate), "yyyy-MM-dd"),
        };
        await AppointmentService.stampAppointment(_body);
        await AppointmentService.updateVisaDate(_bodyVisa);
      });

      if (resCheck.results.check) {
        const MySwal = withReactContent(Swal);

        Swal.fire({
          title: "Do you want to Cancel Agency?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Save",
        }).then(async (result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            Swal.fire("Saved!", "", "success");
            const bodyCancel = {
              personalID: docDetail?.personalId,
            };
            await AppointmentService.AgencyCancel(bodyCancel);
            await getAppointment();
          }
        });
      }

      if (res.status && resVisa.status) {
        await getAppointment();
      }
    } catch (error) {
      console.error(error);
      alert("Something wrong!");
    }

    hideLoading();
  };
  const handleClose = async (value) => {
    setOpen(false);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const dateDiff = (startingDate, endingDate) => {
    var startDate = new Date(
      new Date(startingDate).toISOString().substr(0, 10)
    );
    if (!endingDate) {
      endingDate = new Date().toISOString().substr(0, 10); // need date in YYYY-MM-DD format
    }
    var endDate = new Date(endingDate);
    if (startDate > endDate) {
      var swap = startDate;
      startDate = endDate;
      endDate = swap;
    }
    var startYear = startDate.getFullYear();
    var february =
      (startYear % 4 === 0 && startYear % 100 !== 0) || startYear % 400 === 0
        ? 29
        : 28;
    var daysInMonth = [31, february, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    var yearDiff = endDate.getFullYear() - startYear;
    var monthDiff = endDate.getMonth() - startDate.getMonth();
    if (monthDiff < 0) {
      yearDiff--;
      monthDiff += 12;
    }
    var dayDiff = endDate.getDate() - startDate.getDate();
    if (dayDiff < 0) {
      if (monthDiff > 0) {
        monthDiff--;
      } else {
        yearDiff--;
        monthDiff = 11;
      }
      dayDiff += daysInMonth[startDate.getMonth()];
    }

    let text = "";
    if (yearDiff > 0) {
      text += yearDiff + " Years ";
    }
    if (monthDiff > 0) {
      text += monthDiff + " Months ";
    }
    // if (dayDiff > 0) {
    text += dayDiff + " Days ";
    // }
    // return yearDiff + 'Y ' + monthDiff + 'M ' + dayDiff + 'D';
    return text;
  };

  const CalAmount = (startingDate, endingDate) => {
    let y = 0;
    let total = 0;
    var startDate = new Date(
      new Date(startingDate).toISOString().substr(0, 10)
    );
    if (!endingDate) {
      endingDate = new Date().toISOString().substr(0, 10); // need date in YYYY-MM-DD format
    }
    var endDate = new Date(endingDate);
    if (startDate > endDate) {
      var swap = startDate;
      startDate = endDate;
      endDate = swap;
    }
    var startYear = startDate.getFullYear();
    var february =
      (startYear % 4 === 0 && startYear % 100 !== 0) || startYear % 400 === 0
        ? 29
        : 28;
    var daysInMonth = [31, february, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    var yearDiff = endDate.getFullYear() - startYear;
    var monthDiff = endDate.getMonth() - startDate.getMonth();
    if (monthDiff < 0) {
      yearDiff--;
      monthDiff += 12;
    }
    var dayDiff = endDate.getDate() - startDate.getDate();
    if (dayDiff < 0) {
      if (monthDiff > 0) {
        monthDiff--;
      } else {
        yearDiff--;
        monthDiff = 11;
      }
      dayDiff += daysInMonth[startDate.getMonth()];
    }

    let text = "";
    if (yearDiff > 0) {
      text += yearDiff + " Years ";
      y = yearDiff;
    }
    if (monthDiff > 0) {
      text += monthDiff + " Months ";
      y = yearDiff + 1;
    }
    if (monthDiff == 0 && dayDiff > 0) {
      text += monthDiff + " Months ";
      y = yearDiff + 1;
    }
    total = y * 10000;
    // if (dayDiff > 0) {
    // }

    return total.toLocaleString(undefined, { maximumFractionDigits: 2 });
  };

  return (
    <Paper className={classes.paper}>
      {/* {console.log(countryEmbassy)} */}
      <div className={classes.root}>
        <ChangeUserPass open={open} msg={messageDialog} onClose={handleClose} />
        <DocumentUpload
          open={openDocUpload}
          onClose={() => {
            setOpenDocUpload(false);
          }}
        />
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={value} onChange={handleChange}>
            <Tab label="นัดหมายประทับตรา" />
            {(stampDetail?.stampStatus == "P" ||
              stampDetail?.stampStatus == "C") && (
              <Tab label="ยื่นเอกสารประทับตรา" />
            )}
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <div
            className={classes.wrapDocDetail}
            style={{
              borderBottom: "1px solid lightgray",
              paddingBottom: "40px",
            }}
          >
            {/* <div className={classes.appTitle}>
          ข้อมูลการยื่นคำขอ
        </div> */}

            <Grid container spacing={3}>
              <Grid item xs={12} md={8}>
                <div className={classes.appValue}>
                  <div
                    className={classes.appValue1}
                    style={{ marginRight: "15px", width: 105 }}
                  >
                    วันที่นัดหมาย
                  </div>
                  <div className={classes.appValue3}>
                    {!editMode && (
                      <>
                        <div
                          className={classes.appointmentDate}
                          style={{
                            color: "#2DCE98",
                            backgroundColor: "transparent",
                            border: "1px solid #2DCE98",
                          }}
                        >
                          <div className={classes.wrapAppointmentDate}>
                            <CheckIcon style={{ marginRight: 10 }} />
                            <span>
                              {stampDetail?.stampDate &&
                                format(
                                  new Date(stampDetail?.stampDate),
                                  "yyyy-MM-dd"
                                )}{" "}
                              : {stampDetail?.stampTimeValue} น.
                            </span>
                          </div>
                        </div>

                        {(stampDetail?.stampStatus == "P" ||
                          (stampDetail?.stampStatus == "C" &&
                            stampDetail?.statusProcessId !== "C")) && (
                          <>
                            <Button
                              style={{ marginLeft: 30 }}
                              variant="contained"
                              color="primary"
                              size="small"
                              onClick={() => {
                                setEditMode(true);
                              }}
                            >
                              แก้ไข
                            </Button>
                            <Button
                              style={{ marginLeft: 5 }}
                              variant="outlined"
                              color="primary"
                              size="small"
                              onClick={async () => {
                                if (
                                  !window.confirm(
                                    "Do you want to cancel appointment?"
                                  )
                                ) {
                                  return;
                                }

                                const body = {
                                  draftId: draftId,
                                  stampDate: format(
                                    new Date(appDate),
                                    "yyyy-MM-dd"
                                  ),
                                  status: false,
                                };

                                personalO.forEach(async (x) => {
                                  const _body = {
                                    draftId: x?.draftId,
                                    stampDate: format(
                                      new Date(appDate),
                                      "yyyy-MM-dd"
                                    ),
                                    status: false,
                                  };
                                  await AppointmentService.stampAppointment(
                                    _body
                                  );
                                });

                                const res =
                                  await AppointmentService.stampAppointment(
                                    body
                                  );
                                if (res.status) {
                                  await getAppointment();
                                }
                              }}
                            >
                              ยกเลิก
                            </Button>
                          </>
                        )}
                      </>
                    )}
                    {editMode && (
                      <>
                        <DatePicker
                          style={{ width: 250, marginRight: 5 }}
                          className={classes.formControl}
                          inputVariant="outlined"
                          openTo="year"
                          format="DD-MM-YYYY"
                          label="Appointment Date"
                          views={["year", "month", "date"]}
                          name={`appointmentDate`}
                          maxDate={maxDate}
                          minDate={minDate}
                          value={appDate}
                          onChange={async (e) => {
                            setAppDate(e);

                            setApptimeCf("");
                            let newDate = format(new Date(e), "yyyy/MM/dd");

                            try {
                              const response = await HttpClient.get(
                                `/api/stamp/time/list?StampDate=${newDate}`
                              );
                              setTimeApp(response.results);

                              if (response.status) return response;
                              return Promise.reject(response);
                            } catch (error) {
                              const newError = error;
                              throw newError;
                            }
                          }}
                        />

                        <FormControl style={{ width: 150, marginRight: 10 }}>
                          <InputLabel>Time</InputLabel>
                          <Select
                            value={appTimeCf}
                            label="Time"
                            variant="outlined"
                            onChange={(e) => {
                              setApptimeCf(e.target.value);
                            }}
                          >
                            <MenuItem value="" disabled>
                              Choose Time
                            </MenuItem>

                            {Timeapp.map((x) => (
                              <MenuItem
                                key={x.stampTimeID}
                                value={x.stampTimeID}
                              >
                                {x.stampTimeValue}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleOnStampDate}
                        >
                          ยืนยันวันนัดประทับตรา
                        </Button>
                      </>
                    )}
                  </div>
                </div>
                <div className={classes.appValue}>
                  <div
                    className={classes.appValue1}
                    style={{ marginRight: "15px", width: 105 }}
                  >
                    Visa Valid Date
                  </div>
                  <div className={classes.appValue3}>
                    {!editMode && (
                      <>
                        <div
                          className={classes.appointmentDate}
                          style={{
                            color: "#2DCE98",
                            backgroundColor: "transparent",
                            border: "1px solid #2DCE98",
                          }}
                        >
                          <div className={classes.wrapAppointmentDate}>
                            <CheckIcon style={{ marginRight: 10 }} />
                            <span>
                              {docDetail?.visaValidDate &&
                                format(
                                  new Date(docDetail?.visaValidDate),
                                  "yyyy-MM-dd"
                                )}
                            </span>
                          </div>
                        </div>
                      </>
                    )}

                    {editMode && (
                      <>
                        <DatePicker
                          style={{ width: 200, marginRight: 15 }}
                          className={classes.formControl}
                          inputVariant="outlined"
                          openTo="year"
                          format="DD-MM-YYYY"
                          label="Visa Valid Date"
                          views={["year", "month", "date"]}
                          name={`visaValidDate`}
                          minDate={visaMinDate}
                          maxDate={visaMaxDate}
                          value={visaDate}
                          onChange={(e) => {
                            setVisaDate(e);
                          }}
                        />
                      </>
                    )}
                  </div>
                </div>
                <div
                  className={classes.appValue1}
                  style={{
                    color: "rgb(45, 206, 152)",
                    fontSize: "20px",
                    marginTop: "9px",
                  }}
                >
                  Visa Period :
                  <span style={{ marginLeft: 10 }}>
                    {!editMode &&
                      minDate &&
                      docDetail?.visaValidDate &&
                      dateDiff(minDate, docDetail?.visaValidDate)}
                    {editMode &&
                      minDate &&
                      visaDate &&
                      dateDiff(minDate, visaDate)}
                  </span>
                </div>

                {visaValidDetail && (
                  <div
                    className={classes.appValue1}
                    style={{
                      color: "rgb(45, 206, 152)",
                      fontSize: "20px",
                      marginTop: "9px",
                    }}
                  >
                    Contract Term :
                    <span style={{ marginLeft: 10 }}>
                      {visaValidDetail?.contractTermType === "Y" && (
                        <>
                          {visaValidDetail?.contractYear} Years{" "}
                          {visaValidDetail?.contractMonth} Months
                        </>
                      )}
                      {visaValidDetail?.contractTermType === "P" &&
                        visaValidDetail?.contractPeriodFrom &&
                        visaValidDetail?.contractPeriodTo && (
                          <>
                            {format(
                              new Date(visaValidDetail?.contractPeriodFrom),
                              "yyyy-MM-dd"
                            )}{" "}
                            -{" "}
                            {format(
                              new Date(visaValidDetail?.contractPeriodTo),
                              "yyyy-MM-dd"
                            )}
                          </>
                        )}
                      {visaValidDetail?.contractTermType === "O" && (
                        <>{visaValidDetail?.contractOther}</>
                      )}
                    </span>
                  </div>
                )}

                {visaValidDetail && (
                  <div
                    className={classes.appValue1}
                    style={{
                      color: "rgb(45, 206, 152)",
                      fontSize: "20px",
                      marginTop: "9px",
                    }}
                  >
                    Amount :
                    <span style={{ marginLeft: 10 }}>
                      {!editMode &&
                        minDate &&
                        docDetail?.visaValidDate &&
                        CalAmount(minDate, docDetail?.visaValidDate)}
                      {editMode &&
                        minDate &&
                        visaDate &&
                        CalAmount(minDate, visaDate)}
                      {/* {visaValidDetail?.contractTermType === "Y" && (
                        <>{CalAmount(minDate, docDetail?.visaValidDate)}</>
                      )}{" "} */}
                      Baht
                    </span>
                  </div>
                )}
                <div></div>
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                style={{
                  alignItems: "start",
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <div style={{ textAlign: "right" }}>
                  <div
                    style={{
                      color: "#5F5F5F",
                      fontWeight: "500",
                      fontSize: "16px",
                    }}
                  >
                    เลขที่เอกสาร
                  </div>

                  <div
                    style={{
                      color: "#1094D8",
                      fontWeight: "500",
                      marginTop: "5px",
                      fontSize: "20px",
                    }}
                  >
                    {docDetail?.smartNo}
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
          <div
            className={classes.wrapDocDetail}
            style={{
              borderBottom: "1px solid lightgray",
              paddingBottom: "40px",
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div
                  style={{
                    color: "rgb(23, 43, 77)",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  สถานที่ประทับตรา
                </div>
              </Grid>

              <Grid item xs={12} md={6}>
                <FormGroup row style={{ display: "block" }}>
                  <FormControlLabel
                    control={
                      <Radio
                        disabled={!editMode}
                        name="overseas"
                        value={formik.values.overseas}
                        checked={Boolean(formik.values.overseas)}
                        onClick={() => {
                          formik.setFieldValue("overseas", true);
                          formik.setFieldValue("thailand", false);
                          formik.setFieldValue("theImmigrationBureauID", null);
                        }}
                      />
                    }
                    label="Overseas; Thai Embassy or Consulate in"
                  />

                  <div className={classes.flexRow}>
                    <FormControl
                      disabled={!editMode}
                      variant="outlined"
                      className={classes.formControl}
                      error={isError("countryId", formik)}
                    >
                      <InputLabel>Country</InputLabel>
                      <Select
                        disabled={!editMode}
                        style={{ marginRight: 10, width: 200 }}
                        label="Country"
                        name="countryId"
                        value={formik.values.countryId || ""}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        {countryEmbassy.map((country) => (
                          <MenuItem
                            value={country.countryId}
                            key={country.countryId}
                          >
                            {country.countryName}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText error={isError("countryId", formik)}>
                        {getErrorMessage("countryId", formik)}
                      </FormHelperText>
                    </FormControl>
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                      error={isError("cityId", formik)}
                      disabled={!editMode}
                    >
                      <InputLabel>City</InputLabel>
                      <Select
                        disabled={!editMode}
                        style={{ marginRight: 10, width: 200 }}
                        label="City"
                        name="cityId"
                        value={formik.values.cityId || ""}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        {get(
                          countryEmbassy.filter(
                            (country) =>
                              country.countryId === formik.values.countryId
                          ),
                          "0.cityConfig",
                          []
                        ).map((country) => (
                          <MenuItem value={country.cityID} key={country.cityID}>
                            {country.cityName}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText error={isError("cityId", formik)}>
                        {getErrorMessage("cityId", formik)}
                      </FormHelperText>
                    </FormControl>
                  </div>
                </FormGroup>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormGroup row style={{ display: "block" }}>
                  <FormControlLabel
                    control={
                      <Radio
                        disabled={!editMode}
                        name="thailand"
                        value={formik.values.thailand}
                        checked={Boolean(formik.values.thailand)}
                        onClick={() => {
                          formik.setFieldValue("thailand", true);
                          formik.setFieldValue("overseas", false);
                          formik.setFieldValue("countryId", null);
                          formik.setFieldValue("cityId", null);
                        }}
                      />
                    }
                    label="Thailand"
                  />
                  <div className={classes.flexRow} style={{ flex: 1 }}>
                    <FormControl
                      disabled={!editMode}
                      variant="outlined"
                      className={classes.formControl}
                      style={{ width: "100%" }}
                      error={isError("theImmigrationBureauID", formik)}
                    >
                      <InputLabel>The Immigration Bureau</InputLabel>
                      <Select
                        disabled={!editMode}
                        style={{ marginRight: 10, width: "100%" }}
                        label="The Immigration Bureau"
                        name="theImmigrationBureauID"
                        id="theImmigrationBureauID"
                        key={formik.values.theImmigrationBureauID}
                        value={formik.values.theImmigrationBureauID}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        {theImmigrationBureauConfig.map(
                          (theImmigrationBureau) => (
                            <MenuItem
                              value={
                                theImmigrationBureau.theImmigrationBureauID
                              }
                              key={theImmigrationBureau.theImmigrationBureauID}
                            >
                              {theImmigrationBureau.theImmigrationBureauName}
                            </MenuItem>
                          )
                        )}
                      </Select>
                      <FormHelperText
                        error={isError("theImmigrationBureauID", formik)}
                      >
                        {getErrorMessage("theImmigrationBureauID", formik)}
                      </FormHelperText>
                    </FormControl>
                  </div>
                </FormGroup>
              </Grid>
            </Grid>
          </div>

          <div
            className={classes.wrapDocDetail}
            style={{
              borderBottom: "1px solid lightgray",
              paddingBottom: "40px",
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div
                  style={{
                    color: "rgb(23, 43, 77)",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  ข้อมูลผู้ยื่นหลัก
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>ชื่อ-สกุล</div>
                <div className={classes.appValue2}>
                  {docDetail?.firstname} {docDetail?.lastname}
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>หนังสือเดินทางเลขที่</div>
                <div className={classes.appValue2}>{docDetail?.passport}</div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>ประเภท VISA</div>
                <div className={classes.appValue2}>
                  {VISA_TYPE_NAME[docDetail?.smartserviceId]}
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>วันที่ยื่น</div>
                <div className={classes.appValue2}>
                  {docDetail?.smartDate &&
                    format(new Date(docDetail?.smartDate), "yyyy-MM-dd")}
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>วันที่อนุมัติ</div>
                <div className={classes.appValue2} style={{ color: "#2DCE98" }}>
                  {/* {stampDetail?.approvedDate
                    ? format(new Date(stampDetail?.approvedDate), "yyyy-MM-dd")
                    : "-"} */}
                  {docDetail?.visaStartDate
                    ? format(new Date(docDetail?.visaStartDate), "yyyy-MM-dd")
                    : "-"}
                </div>
              </Grid>
              {stampDetail && (
                <div
                  className={classes.wrapDocDetail}
                  style={{
                    textAlign: "center",
                    paddingBottom: "40px",
                  }}
                >
                  <div
                    className={classes.appointmentDate2}
                    onClick={async () => {
                      const body = {
                        draftId: stampDetail?.draftId,
                      };
                      const blob = await AppointmentService.getReportAppoint(
                        body
                      );

                      const blobFile = new File([blob], "Appointment.pdf", {
                        type: mime.getType(".pdf"),
                      });

                      window.open(
                        URL.createObjectURL(blobFile, "Appointment.pdf"),
                        "_blank"
                      );
                    }}
                    style={{ marginRight: 15, cursor: "pointer" }}
                  >
                    <div className={classes.wrapAppointmentDate}>
                      <PrintIcon style={{ marginRight: 10 }} />
                      <span>พิมพ์ใบนัด</span>
                    </div>
                  </div>

                  {/* <div
                className={classes.appointmentDate2}
                style={{ marginRight: 15, cursor: "pointer" }}
                onClick={async () => {
                  const body = {
                    draftId: stampDetail?.draftId,
                  };
                  const blob = await AppointmentService.getReportPayment(body);

                  const blobFile = new File([blob], "payment.pdf", {
                    type: mime.getType(".pdf"),
                  });

                  window.open(
                    URL.createObjectURL(blobFile, "payment.pdf"),
                    "_blank"
                  );
                }}
              >
                <div className={classes.wrapAppointmentDate}>
                  <PrintIcon style={{ marginRight: 10 }} />
                  <span>พิมพ์ใบชำระเงิน</span>
                </div>
              </div> */}

                  {/* {true && (
                <div
                  className={classes.appointmentDate2}
                  style={{ marginRight: 15, cursor: "pointer" }}
                  onClick={async () => {
                    const body = {
                      draftId: stampDetail?.draftId,
                    };
                    const blob = await AppointmentService.getReportSeal(body);

                    const blobFile = new File([blob], "seal.pdf", {
                      type: mime.getType(".pdf"),
                    });

                    window.open(
                      URL.createObjectURL(blobFile, "seal.pdf"),
                      "_blank"
                    );
                  }}
                >
                  <div className={classes.wrapAppointmentDate}>
                    <PrintIcon style={{ marginRight: 10 }} />
                    <span>พิมพ์ใบประทับตรา</span>
                  </div>
                </div>
              )} */}
                  {true && (
                    <div
                      className={classes.appointmentDate2}
                      style={{ marginRight: 15, cursor: "pointer" }}
                      onClick={async () => {
                        const body = {
                          draftId: stampDetail?.draftId,
                        };
                        const blob =
                          await AppointmentService.getReportResultSmart(body);

                        const blobFile = new File([blob], "Result.pdf", {
                          type: mime.getType(".pdf"),
                        });

                        window.open(
                          URL.createObjectURL(blobFile, "Result.pdf"),
                          "_blank"
                        );
                      }}
                    >
                      <div className={classes.wrapAppointmentDate}>
                        <PrintIcon style={{ marginRight: 10 }} />
                        <span>พิมพ์ใบแจ้งผล</span>
                      </div>
                    </div>
                  )}
                  {/* {true && (
                <div
                  className={classes.appointmentDate2}
                  style={{ marginRight: 15, cursor: "pointer" }}
                  onClick={async () => {
                    const body = {
                      draftId: stampDetail?.draftId,
                    };
                    const blob = await AppointmentService.getReportBenefits(
                      body
                    );

                    const blobFile = new File([blob], "benefits.pdf", {
                      type: mime.getType(".pdf"),
                    });

                    window.open(
                      URL.createObjectURL(blobFile, "benefits.pdf"),
                      "_blank"
                    );
                  }}
                >
                  <div className={classes.wrapAppointmentDate}>
                    <PrintIcon style={{ marginRight: 10 }} />
                    <span>พิมพ์แจ้งสิทธิ์</span>
                  </div>
                </div>
              )} */}
                </div>
              )}

              {/* {stampDetail?.stampStatus == "C" && (
            <div className={classes.wrapDocDetail} style={{}}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <div
                    style={{
                      color: "rgb(23, 43, 77)",
                      fontWeight: "bold",
                      fontSize: "16px",
                      marginBottom: 15,
                    }}
                  >
                    รูปถ่าย
                  </div>
                  <div>
                    <img className={classes.sigImage} src={imageDataUri} />
                  </div>
                </Grid>

                <Grid item xs={12} md={8}>
                  <div
                    style={{
                      color: "rgb(23, 43, 77)",
                      fontWeight: "bold",
                      fontSize: "16px",
                      marginBottom: 15,
                    }}
                  >
                    ลายเซ็นต์
                  </div>
                  <div>
                    <img
                      className={classes.sigImage}
                      style={{
                        width: "100%",
                        height: "170px",
                        borderRadius: "15px",
                        backgroundSize: "200px 50px",
                        backgroundColor: "white",
                      }}
                      src={signDataUri}
                    />
                  </div>
                </Grid>
              </Grid>
            </div>
          )} */}
            </Grid>
          </div>

          {personalO.length > 0 ? (
            <div
              className={classes.wrapDocDetail}
              style={{
                borderBottom: "1px solid lightgray",
                paddingBottom: "40px",
              }}
            >
              {personalO.map((x, i) => (
                <>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <div
                        style={{
                          color: "rgb(23, 43, 77)",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        ข้อมูลผู้ติดตามที่ {i + 1}
                      </div>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <div className={classes.appValue1}>ชื่อ-สกุล</div>
                      <div className={classes.appValue2}>
                        {x?.firstname} {x?.lastname}
                      </div>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <div className={classes.appValue1}>
                        หนังสือเดินทางเลขที่
                      </div>
                      <div className={classes.appValue2}>{x?.passport}</div>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <div className={classes.appValue1}>ประเภท VISA</div>
                      <div className={classes.appValue2}>
                        {x?.smartserviceReferName}
                      </div>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <div className={classes.appValue1}>วันที่ยื่น</div>
                      <div className={classes.appValue2}>
                        {x?.smartDate &&
                          format(new Date(x?.smartDate), "yyyy-MM-dd")}
                      </div>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <div className={classes.appValue1}>วันที่อนุมัติ</div>
                      <div
                        className={classes.appValue2}
                        style={{ color: "#2DCE98" }}
                      >
                        {/* {stampDetail?.approvedDate
     ? format(new Date(stampDetail?.approvedDate), "yyyy-MM-dd")
     : "-"} */}
                        {x?.preApproveDate
                          ? format(new Date(x?.preApproveDate), "yyyy-MM-dd")
                          : "-"}
                      </div>
                    </Grid>

                    {personalO && (
                      <div
                        className={classes.wrapDocDetail}
                        style={{
                          textAlign: "center",
                          paddingBottom: "40px",
                        }}
                      >
                        <div
                          className={classes.appointmentDate2}
                          onClick={async () => {
                            const body = {
                              draftId: x?.draftId,
                            };
                            const blob =
                              await AppointmentService.getReportAppoint(body);

                            const blobFile = new File(
                              [blob],
                              "Appointment.pdf",
                              {
                                type: mime.getType(".pdf"),
                              }
                            );

                            window.open(
                              URL.createObjectURL(blobFile, "Appointment.pdf"),
                              "_blank"
                            );
                          }}
                          style={{ marginRight: 15, cursor: "pointer" }}
                        >
                          <div className={classes.wrapAppointmentDate}>
                            <PrintIcon style={{ marginRight: 10 }} />
                            <span>พิมพ์ใบนัด</span>
                          </div>
                        </div>

                        {/* <div
                className={classes.appointmentDate2}
                style={{ marginRight: 15, cursor: "pointer" }}
                onClick={async () => {
                  const body = {
                    draftId: stampDetail?.draftId,
                  };
                  const blob = await AppointmentService.getReportPayment(body);

                  const blobFile = new File([blob], "payment.pdf", {
                    type: mime.getType(".pdf"),
                  });

                  window.open(
                    URL.createObjectURL(blobFile, "payment.pdf"),
                    "_blank"
                  );
                }}
              >
                <div className={classes.wrapAppointmentDate}>
                  <PrintIcon style={{ marginRight: 10 }} />
                  <span>พิมพ์ใบชำระเงิน</span>
                </div>
              </div> */}

                        {/* {true && (
                <div
                  className={classes.appointmentDate2}
                  style={{ marginRight: 15, cursor: "pointer" }}
                  onClick={async () => {
                    const body = {
                      draftId: stampDetail?.draftId,
                    };
                    const blob = await AppointmentService.getReportSeal(body);

                    const blobFile = new File([blob], "seal.pdf", {
                      type: mime.getType(".pdf"),
                    });

                    window.open(
                      URL.createObjectURL(blobFile, "seal.pdf"),
                      "_blank"
                    );
                  }}
                >
                  <div className={classes.wrapAppointmentDate}>
                    <PrintIcon style={{ marginRight: 10 }} />
                    <span>พิมพ์ใบประทับตรา</span>
                  </div>
                </div>
              )} */}
                        {true && (
                          <div
                            className={classes.appointmentDate2}
                            style={{ marginRight: 15, cursor: "pointer" }}
                            onClick={async () => {
                              const body = {
                                draftId: x?.draftId,
                              };
                              const blob =
                                await AppointmentService.getReportResultSmart(
                                  body
                                );

                              const blobFile = new File([blob], "Result.pdf", {
                                type: mime.getType(".pdf"),
                              });

                              window.open(
                                URL.createObjectURL(blobFile, "Result.pdf"),
                                "_blank"
                              );
                            }}
                          >
                            <div className={classes.wrapAppointmentDate}>
                              <PrintIcon style={{ marginRight: 10 }} />
                              <span>พิมพ์ใบแจ้งผล</span>
                            </div>
                          </div>
                        )}
                        {/* {true && (
                <div
                  className={classes.appointmentDate2}
                  style={{ marginRight: 15, cursor: "pointer" }}
                  onClick={async () => {
                    const body = {
                      draftId: stampDetail?.draftId,
                    };
                    const blob = await AppointmentService.getReportBenefits(
                      body
                    );

                    const blobFile = new File([blob], "benefits.pdf", {
                      type: mime.getType(".pdf"),
                    });

                    window.open(
                      URL.createObjectURL(blobFile, "benefits.pdf"),
                      "_blank"
                    );
                  }}
                >
                  <div className={classes.wrapAppointmentDate}>
                    <PrintIcon style={{ marginRight: 10 }} />
                    <span>พิมพ์แจ้งสิทธิ์</span>
                  </div>
                </div>
              )} */}
                      </div>
                    )}
                  </Grid>
                </>
              ))}
            </div>
          ) : null}

          <div
            className={classes.wrapDocDetail}
            style={{
              borderBottom: "1px solid lightgray",
              paddingBottom: "40px",
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div
                  style={{
                    color: "rgb(23, 43, 77)",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  เจ้าหน้าที่ที่รับผิดชอบ
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>ชื่อ-สกุล</div>
                <div className={classes.appValue2}>{docDetail?.staffname}</div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>เบอร์โทรศัพท์</div>
                <div className={classes.appValue2}>{docDetail?.phone}</div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>อีเมล</div>
                <div className={classes.appValue2}>{docDetail?.staffemail}</div>
              </Grid>
            </Grid>
          </div>

          {/* <div
            className={classes.wrapDocDetail}
            style={{
              borderBottom: "1px solid lightgray",
              paddingBottom: "40px",
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div
                  style={{
                    color: "rgb(23, 43, 77)",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  เจ้าหน้าที่ตม.
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>ชื่อ-สกุล</div>
                <div className={classes.appValue2}>
                  {stampDetail?.empAssignedFirstName}{" "}
                  {stampDetail?.empAssignedLastName}
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>เบอร์โทรศัพท์</div>
                <div className={classes.appValue2}></div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>อีเมล</div>
                <div className={classes.appValue2}>
                  {stampDetail?.empAssignedEmail}
                </div>
              </Grid>
            </Grid>
          </div> */}
        </TabPanel>

        {(stampDetail?.stampStatus == "P" ||
          stampDetail?.stampStatus == "C") && (
          <TabPanel value={value} index={1}>
            <div
              className={classes.wrapDocDetail}
              style={{
                borderBottom: "1px solid lightgray",
                paddingBottom: "40px",
              }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} md={8}>
                  {/* <div className={classes.appValue}>
                    <div
                      className={classes.appValue1}
                      style={{ marginRight: "15px" }}
                    >
                      วันที่นัดหมาย
                    </div>
                    <div className={classes.appValue3}>
                      {!editMode && (
                        <>
                          <div
                            className={classes.appointmentDate}
                            style={{
                              color: "#2DCE98",
                              backgroundColor: "transparent",
                              border: "1px solid #2DCE98",
                            }}
                          >
                            <div className={classes.wrapAppointmentDate}>
                              <CheckIcon style={{ marginRight: 10 }} />
                              <span>
                                {stampDetail?.stampDate &&
                                  format(
                                    new Date(stampDetail?.stampDate),
                                    "yyyy-MM-dd"
                                  )}{" "}
                                : {stampDetail?.stampTimeValue} น.
                              </span>
                            </div>
                          </div>

                          {stampDetail?.stampStatus == "P" && (
                            <>
                              <Button
                                style={{ marginLeft: 30 }}
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={() => {
                                  setEditMode(true);
                                }}
                              >
                                แก้ไข
                              </Button>
                              <Button
                                style={{ marginLeft: 5 }}
                                variant="outlined"
                                color="primary"
                                size="small"
                                onClick={async () => {
                                  if (
                                    !window.confirm(
                                      "Do you want to cancel appointment?"
                                    )
                                  ) {
                                    return;
                                  }

                                  const body = {
                                    draftId: draftId,
                                    stampDate: format(
                                      new Date(appDate),
                                      "yyyy-MM-dd"
                                    ),
                                    status: false,
                                  };
                                  const res =
                                    await AppointmentService.stampAppointment(
                                      body
                                    );
                                  if (res.status) {
                                    await getAppointment();
                                  }
                                }}
                              >
                                ยกเลิก
                              </Button>
                            </>
                          )}
                        </>
                      )}
                      {editMode && (
                        <>
                          <DatePicker
                            style={{ width: 200, marginRight: 15 }}
                            className={classes.formControl}
                            inputVariant="outlined"
                            openTo="year"
                            format="DD-MM-YYYY"
                            label="Appointment Date"
                            views={["year", "month", "date"]}
                            minDate={minDate}
                            maxDate={maxDate}
                            name={`appointmentDate`}
                            value={appDate}
                            onChange={async (e) => {
                              setAppDate(e);
                              setApptimeCf("");
                              let newDate = format(new Date(e), "yyyy/MM/dd");
                              console.log(
                                format(new Date(newDate), "dd-MM-yyyy")
                              );
                              try {
                                const response = await HttpClient.get(
                                  `/api/stamp/time/list?StampDate=${newDate}`
                                );
                                setTimeApp(response.results);
                                console.log(response);
                                if (response.status) return response;
                                return Promise.reject(response);
                              } catch (error) {
                                const newError = error;
                                throw newError;
                              }
                            }}
                          />
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleOnStampDate}
                          >
                            ยืนยันวันนัดประทับตรา
                          </Button>
                        </>
                      )}
                    </div>
                  </div> */}
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  style={{
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  <div style={{ textAlign: "right" }}>
                    <div
                      style={{
                        color: "#5F5F5F",
                        fontWeight: "500",
                        fontSize: "16px",
                      }}
                    >
                      ผู้ถือหลัก
                    </div>

                    <div
                      style={{
                        color: "#1094D8",
                        fontWeight: "500",
                        marginTop: "5px",
                        fontSize: "20px",
                      }}
                    >
                      {docDetail?.firstname}&nbsp;{docDetail?.lastname}
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
            <div
              className={classes.wrapDocDetail}
              style={{
                borderBottom: "1px solid lightgray",
                paddingBottom: "40px",
              }}
            >
              <Grid container spacing={3}>
                <Grid
                  item
                  xs={12}
                  md={4}
                  style={{ borderRight: "1px solid lightgray" }}
                >
                  <div className={classes.middle}>
                    <div
                      style={{ position: "relative", padding: 15 }}
                      className={clsx({
                        [classes.nofile]:
                          (stampDetail?.stampStatus == "P" ||
                            stampDetail?.stampStatus == "C") &&
                          !stampDetail?.stampFileId,
                      })}
                    >
                      {(stampDetail?.stampStatus == "P" ||
                        stampDetail?.stampStatus == "C") && (
                        <div
                          className={classes.appValue1}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <span>เอกสารประทับตรา*</span>
                          {stampDetail?.statusProcessId !== "C" ? (
                            <UploadButton
                              variant="contained"
                              color="warning"
                              id="editstampFileId"
                              size="small"
                              title={"แก้ไข"}
                              style={{
                                textDecoration: "underline",
                                color: "rgb(16, 148, 216)",
                                fontSize: "13px",
                                fontWeight: "500",
                                height: "auto",
                                border: "none",
                              }}
                              onChange={async (event) => {
                                showAdminLoading();
                                const response = await FileService.uploadFile({
                                  file: event.target.files[0],
                                  FileID: null,
                                  Status: true,
                                });

                                const fileId = response.results?.fileID;

                                const res =
                                  await AppointmentService.userStampUploadRequest(
                                    {
                                      draftId: stampDetail?.draftId,
                                      stampFileId: fileId,
                                      workPermitFileId:
                                        stampDetail?.workPermitFileId,
                                      immigrationFileId:
                                        stampDetail?.immigrationFileId,
                                    }
                                  );
                                if (res.status) {
                                  await getAppointment();
                                  hideAdminLoading();
                                  showAlert({
                                    type: ALERT_TYPE.SUCCESS,
                                    title: "Upload complete",
                                    description:
                                      "You have been uploaded document successfully.",
                                    button: [
                                      {
                                        title: "Done",
                                        onClick: () => {
                                          hideAlert();
                                        },
                                      },
                                    ],
                                  });
                                }
                              }}
                            >
                              Edit
                            </UploadButton>
                          ) : null}
                        </div>
                      )}

                      <div className={classes.appValue2}>
                        {(stampDetail?.stampStatus == "P" ||
                          stampDetail?.stampStatus == "C") &&
                          !stampDetail?.stampFileId && (
                            <>
                              <UploadButton
                                size="small"
                                title={"อัปโหลด*"}
                                id="uploadstampFileId"
                                style={{
                                  width: "150px",
                                  height: "auto",
                                  borderColor: "#ED1C24",
                                  color: "#ED1C24",
                                }}
                                onChange={async (event) => {
                                  showAdminLoading();
                                  const response = await FileService.uploadFile(
                                    {
                                      file: event.target.files[0],
                                      FileID: null,
                                      Status: true,
                                    }
                                  );

                                  const fileId = response.results?.fileID;

                                  const res =
                                    await AppointmentService.userStampUploadRequest(
                                      {
                                        draftId: stampDetail?.draftId,
                                        stampFileId: fileId,
                                        workPermitFileId:
                                          stampDetail?.workPermitFileId,
                                        immigrationFileId:
                                          stampDetail?.immigrationFileId,
                                      }
                                    );
                                  if (res.status) {
                                    await getAppointment();
                                    hideAdminLoading();
                                    showAlert({
                                      type: ALERT_TYPE.SUCCESS,
                                      title: "Upload complete",
                                      description:
                                        "You have been uploaded document successfully.",
                                      button: [
                                        {
                                          title: "Done",
                                          onClick: () => {
                                            hideAlert();
                                          },
                                        },
                                      ],
                                    });
                                  }
                                }}
                              />
                              <div
                                style={{
                                  color: "rgb(95, 95, 95)",
                                  fontSize: "10px",
                                  marginTop: "5px",
                                }}
                              >
                                File Upload ( PDF, JPG )
                              </div>
                            </>
                          )}

                        {(stampDetail?.stampStatus == "P" ||
                          stampDetail?.stampStatus == "C") &&
                          stampDetail?.stampFileId && (
                            <>
                              <div
                                style={{ cursor: "pointer", display: "flex" }}
                                onClick={() => {
                                  openFileById(stampDetail?.stampFileId);
                                }}
                              >
                                <div style={{ marginRight: 30 }}>
                                  <img src={"/assets/pdf.svg"} />
                                </div>

                                <div
                                  style={{
                                    color: "rgb(23, 43, 77)",
                                    fontWeight: "bold",
                                    fontSize: "15px",
                                    textDecoration: "underline",
                                  }}
                                >
                                  {/* {stampDetail?.stampFileName}{" "}
                                  {stampDetail?.stampFileExt} */}
                                </div>
                              </div>
                            </>
                          )}
                      </div>
                    </div>
                  </div>
                  {(stampDetail?.stampStatus == "P" ||
                    stampDetail?.stampStatus == "C") &&
                    !stampDetail?.stampFileId && (
                      <div className={classes.requiredDoc}>
                        <span>กรุณาอัปโหลดเอกสาร</span>
                      </div>
                    )}
                </Grid>

                <Grid item xs={12} md={4} style={{}}>
                  <div className={classes.middle}>
                    <div
                      style={{ position: "relative", padding: 15 }}
                      className={clsx({
                        [classes.nofile]:
                          (stampDetail?.stampStatus == "P" ||
                            stampDetail?.stampStatus == "C") &&
                          !stampDetail?.immigrationFileId,
                      })}
                    >
                      {(stampDetail?.stampStatus == "P" ||
                        stampDetail?.stampStatus == "C") && (
                        <div
                          className={classes.appValue1}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <span>ตราขาเข้า*</span>
                          {stampDetail?.statusProcessId !== "C" ? (
                            <UploadButton
                              variant="contained"
                              color="warning"
                              size="small"
                              title={"แก้ไข"}
                              id="editimmigrationFileId"
                              style={{
                                textDecoration: "underline",
                                color: "rgb(16, 148, 216)",
                                fontSize: "13px",
                                fontWeight: "500",
                                height: "auto",
                                border: "none",
                              }}
                              onChange={async (event) => {
                                showAdminLoading();
                                const response = await FileService.uploadFile({
                                  file: event.target.files[0],
                                  FileID: null,
                                  Status: true,
                                });

                                const fileId = response.results?.fileID;

                                const res =
                                  await AppointmentService.userStampUploadRequest(
                                    {
                                      draftId: stampDetail?.draftId,
                                      workPermitFileId:
                                        stampDetail?.workPermitFileId,
                                      stampFileId: stampDetail?.stampFileId,
                                      immigrationFileId: fileId,
                                    }
                                  );

                                if (res.status) {
                                  await getAppointment();
                                  hideAdminLoading();
                                  showAlert({
                                    type: ALERT_TYPE.SUCCESS,
                                    title: "Upload complete",
                                    description:
                                      "You have been uploaded document successfully.",
                                    button: [
                                      {
                                        title: "Done",
                                        onClick: () => {
                                          hideAlert();
                                        },
                                      },
                                    ],
                                  });
                                }
                              }}
                            >
                              Edit
                            </UploadButton>
                          ) : null}
                        </div>
                      )}

                      <div className={classes.appValue2}>
                        {(stampDetail?.stampStatus == "P" ||
                          stampDetail?.stampStatus == "C") &&
                          !stampDetail?.immigrationFileId && (
                            <>
                              <UploadButton
                                size="small"
                                title={"อัปโหลด*"}
                                id="uploadimmigrationFileId"
                                style={{
                                  width: "150px",
                                  height: "auto",
                                  borderColor: "#ED1C24",
                                  color: "#ED1C24",
                                }}
                                onChange={async (event) => {
                                  showAdminLoading();
                                  const response = await FileService.uploadFile(
                                    {
                                      file: event.target.files[0],
                                      FileID: null,
                                      Status: true,
                                    }
                                  );

                                  const fileId = response.results?.fileID;

                                  const res =
                                    await AppointmentService.userStampUploadRequest(
                                      {
                                        draftId: stampDetail?.draftId,
                                        immigrationFileId: fileId,
                                        stampFileId: stampDetail?.stampFileId,
                                        workPermitFileId:
                                          stampDetail?.workPermitFileId,
                                      }
                                    );

                                  if (res.status) {
                                    await getAppointment();
                                    hideAdminLoading();
                                    showAlert({
                                      type: ALERT_TYPE.SUCCESS,
                                      title: "Upload complete",
                                      description:
                                        "You have been uploaded document successfully.",
                                      button: [
                                        {
                                          title: "Done",
                                          onClick: () => {
                                            hideAlert();
                                          },
                                        },
                                      ],
                                    });
                                  }
                                }}
                              />
                              <div
                                style={{
                                  color: "rgb(95, 95, 95)",
                                  fontSize: "10px",
                                  marginTop: "5px",
                                }}
                              >
                                File Upload ( PDF, JPG )
                              </div>
                            </>
                          )}

                        {(stampDetail?.stampStatus == "P" ||
                          stampDetail?.stampStatus == "C") &&
                          stampDetail?.immigrationFileId && (
                            <>
                              <div
                                style={{ cursor: "pointer", display: "flex" }}
                                onClick={() => {
                                  openFileById(stampDetail?.immigrationFileId);
                                }}
                              >
                                <div style={{ marginRight: 30 }}>
                                  <img src={"/assets/pdf.svg"} />
                                </div>

                                <div
                                  style={{
                                    color: "rgb(23, 43, 77)",
                                    fontWeight: "bold",
                                    fontSize: "15px",
                                    textDecoration: "underline",
                                  }}
                                >
                                  {/* {stampDetail?.immigrationFileName}{" "}
                                  {stampDetail?.immigrationFileExt} */}
                                </div>
                              </div>
                            </>
                          )}
                      </div>
                    </div>
                  </div>

                  {(stampDetail?.stampStatus == "P" ||
                    stampDetail?.stampStatus == "C") &&
                    !stampDetail?.stampFileId && (
                      <div className={classes.requiredDoc}>
                        <span>กรุณาอัปโหลดเอกสาร</span>
                      </div>
                    )}
                </Grid>
                <div style={{ marginTop: 5 }}>
                  <center>
                    {docDetail?.statusProcessId == STATUS_PROCESS.Complete &&
                      stampDetail?.stampFileId && (
                        <div
                          className={classes.appointmentDate2}
                          style={{ marginRight: 15, cursor: "pointer" }}
                          onClick={async () => {
                            const body = {
                              draftId: stampDetail?.draftId,
                            };
                            // const blob = await AppointmentService.getReportBenefits(
                            //   body
                            // );
                            const blob =
                              await AppointmentService.getReportNotifyThai(
                                body
                              );

                            const blobFile = new File([blob], "benefits.pdf", {
                              type: mime.getType(".pdf"),
                            });

                            window.open(
                              URL.createObjectURL(blobFile, "benefits.pdf"),
                              "_blank"
                            );
                          }}
                        >
                          <div className={classes.wrapAppointmentDate}>
                            <PrintIcon style={{ marginRight: 10 }} />
                            <span>พิมพ์แจ้งสิทธิ์</span>
                          </div>
                        </div>
                      )}
                    {docDetail?.statusProcessId == STATUS_PROCESS.Complete &&
                      stampDetail?.stampFileId && (
                        <div
                          className={classes.appointmentDate2}
                          style={{ marginRight: 15, cursor: "pointer" }}
                          onClick={async () => {
                            const body = {
                              draftId: stampDetail?.draftId,
                            };
                            const blob =
                              await AppointmentService.getReportNotifyEng(body);

                            const blobFile = new File([blob], "benefits.pdf", {
                              type: mime.getType(".pdf"),
                            });

                            window.open(
                              URL.createObjectURL(blobFile, "benefits.pdf"),
                              "_blank"
                            );
                          }}
                        >
                          <div className={classes.wrapAppointmentDate}>
                            <PrintIcon style={{ marginRight: 10 }} />
                            <span>Print Report Benefits</span>
                          </div>
                        </div>
                      )}
                  </center>
                </div>
              </Grid>
            </div>

            {personalO.map((x, i) => (
              <>
                <div
                  className={classes.wrapDocDetail}
                  style={{
                    borderBottom: "1px solid lightgray",
                    paddingBottom: "40px",
                  }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={8}></Grid>
                    <Grid
                      item
                      xs={12}
                      md={4}
                      style={{
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      <div style={{ textAlign: "right" }}>
                        <div
                          style={{
                            color: "#5F5F5F",
                            fontWeight: "500",
                            fontSize: "16px",
                          }}
                        >
                          ผู้ติดตามที่ {i + 1}
                        </div>

                        <div
                          style={{
                            color: "#1094D8",
                            fontWeight: "500",
                            marginTop: "5px",
                            fontSize: "20px",
                          }}
                        >
                          {x?.firstname}&nbsp;{x?.lastname}
                        </div>
                      </div>
                    </Grid>
                    {StampDetailpersonalO.filter(
                      (xs) => xs.draftId === x.draftId
                    ).map((data, index) => (
                      <>
                        <Grid container spacing={3}>
                          <Grid
                            item
                            xs={12}
                            md={4}
                            style={{ borderRight: "1px solid lightgray" }}
                          >
                            <div className={classes.middle}>
                              <div
                                style={{ position: "relative", padding: 15 }}
                                className={clsx({
                                  [classes.nofile]:
                                    (data?.stampStatus == "P" ||
                                      data?.stampStatus == "C") &&
                                    !data?.stampFileId,
                                })}
                              >
                                {(data?.stampStatus == "P" ||
                                  data?.stampStatus == "C") && (
                                  <div
                                    className={classes.appValue1}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      width: "100%",
                                    }}
                                  >
                                    <span>เอกสารประทับตรา*</span>

                                    {data?.statusProcessId !== "C" ? (
                                      <UploadButton
                                        variant="contained"
                                        color="warning"
                                        id={"editstampFileId" + i}
                                        size="small"
                                        title={"แก้ไข"}
                                        style={{
                                          textDecoration: "underline",
                                          color: "rgb(16, 148, 216)",
                                          fontSize: "13px",
                                          fontWeight: "500",
                                          height: "auto",
                                          border: "none",
                                        }}
                                        onChange={async (event) => {
                                          showAdminLoading();
                                          const response =
                                            await FileService.uploadFile({
                                              file: event.target.files[0],
                                              FileID: null,
                                              Status: true,
                                            });

                                          const fileId =
                                            response.results?.fileID;

                                          const res =
                                            await AppointmentService.userStampUploadRequest(
                                              {
                                                draftId: x?.draftId,
                                                stampFileId: fileId,
                                                workPermitFileId:
                                                  data?.workPermitFileId,
                                                immigrationFileId:
                                                  data?.immigrationFileId,
                                              }
                                            );
                                          if (res.status) {
                                            await getAppointment();
                                            hideAdminLoading();
                                            showAlert({
                                              type: ALERT_TYPE.SUCCESS,
                                              title: "Upload complete",
                                              description:
                                                "You have been uploaded document successfully.",
                                              button: [
                                                {
                                                  title: "Done",
                                                  onClick: () => {
                                                    hideAlert();
                                                  },
                                                },
                                              ],
                                            });
                                          }
                                        }}
                                      >
                                        Edit
                                      </UploadButton>
                                    ) : null}
                                  </div>
                                )}

                                <div className={classes.appValue2}>
                                  {(data?.stampStatus == "P" ||
                                    data?.stampStatus == "C") &&
                                    !data?.stampFileId && (
                                      <>
                                        <UploadButton
                                          size="small"
                                          title={"อัปโหลด*"}
                                          id={"uploadstampFileId" + i}
                                          style={{
                                            width: "150px",
                                            height: "auto",
                                            borderColor: "#ED1C24",
                                            color: "#ED1C24",
                                          }}
                                          onChange={async (event) => {
                                            showAdminLoading();
                                            const response =
                                              await FileService.uploadFile({
                                                file: event.target.files[0],
                                                FileID: null,
                                                Status: true,
                                              });

                                            const fileId =
                                              response.results?.fileID;

                                            const res =
                                              await AppointmentService.userStampUploadRequest(
                                                {
                                                  draftId: x?.draftId,
                                                  stampFileId: fileId,
                                                  workPermitFileId:
                                                    data?.workPermitFileId,
                                                  immigrationFileId:
                                                    data?.immigrationFileId,
                                                }
                                              );
                                            if (res.status) {
                                              await getAppointment();
                                              hideAdminLoading();
                                              showAlert({
                                                type: ALERT_TYPE.SUCCESS,
                                                title: "Upload complete",
                                                description:
                                                  "You have been uploaded document successfully.",
                                                button: [
                                                  {
                                                    title: "Done",
                                                    onClick: () => {
                                                      hideAlert();
                                                    },
                                                  },
                                                ],
                                              });
                                            }
                                          }}
                                        />
                                        <div
                                          style={{
                                            color: "rgb(95, 95, 95)",
                                            fontSize: "10px",
                                            marginTop: "5px",
                                          }}
                                        >
                                          File Upload ( PDF, JPG )
                                        </div>
                                      </>
                                    )}

                                  {(data?.stampStatus == "P" ||
                                    data?.stampStatus == "C") &&
                                    data?.stampFileId && (
                                      <>
                                        <div
                                          style={{
                                            cursor: "pointer",
                                            display: "flex",
                                          }}
                                          onClick={() => {
                                            openFileById(data?.stampFileId);
                                          }}
                                        >
                                          <div style={{ marginRight: 30 }}>
                                            <img src={"/assets/pdf.svg"} />
                                          </div>

                                          <div
                                            style={{
                                              color: "rgb(23, 43, 77)",
                                              fontWeight: "bold",
                                              fontSize: "15px",
                                              textDecoration: "underline",
                                            }}
                                          >
                                            {/* {stampDetail?.stampFileName}{" "}
               {stampDetail?.stampFileExt} */}
                                          </div>
                                        </div>
                                      </>
                                    )}
                                </div>
                              </div>
                            </div>
                            {(data?.stampStatus == "P" ||
                              data?.stampStatus == "C") &&
                              !data?.stampFileId && (
                                <div className={classes.requiredDoc}>
                                  <span>กรุณาอัปโหลดเอกสาร</span>
                                </div>
                              )}
                          </Grid>

                          <Grid item xs={12} md={4} style={{}}>
                            <div className={classes.middle}>
                              <div
                                style={{ position: "relative", padding: 15 }}
                                className={clsx({
                                  [classes.nofile]:
                                    (data?.stampStatus == "P" ||
                                      data?.stampStatus == "C") &&
                                    !data?.immigrationFileId,
                                })}
                              >
                                {(data?.stampStatus == "P" ||
                                  data?.stampStatus == "C") && (
                                  <div
                                    className={classes.appValue1}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      width: "100%",
                                    }}
                                  >
                                    <span>ตราขาเข้า*</span>
                                    {data?.statusProcessId !== "C" ? (
                                      <UploadButton
                                        variant="contained"
                                        color="warning"
                                        size="small"
                                        title={"แก้ไข"}
                                        id={"editimmigrationFileId" + i}
                                        style={{
                                          textDecoration: "underline",
                                          color: "rgb(16, 148, 216)",
                                          fontSize: "13px",
                                          fontWeight: "500",
                                          height: "auto",
                                          border: "none",
                                        }}
                                        onChange={async (event) => {
                                          showAdminLoading();
                                          const response =
                                            await FileService.uploadFile({
                                              file: event.target.files[0],
                                              FileID: null,
                                              Status: true,
                                            });

                                          const fileId =
                                            response.results?.fileID;

                                          const res =
                                            await AppointmentService.userStampUploadRequest(
                                              {
                                                draftId: x?.draftId,
                                                workPermitFileId:
                                                  data?.workPermitFileId,
                                                stampFileId: data?.stampFileId,
                                                immigrationFileId: fileId,
                                              }
                                            );

                                          if (res.status) {
                                            await getAppointment();
                                            hideAdminLoading();
                                            showAlert({
                                              type: ALERT_TYPE.SUCCESS,
                                              title: "Upload complete",
                                              description:
                                                "You have been uploaded document successfully.",
                                              button: [
                                                {
                                                  title: "Done",
                                                  onClick: () => {
                                                    hideAlert();
                                                  },
                                                },
                                              ],
                                            });
                                          }
                                        }}
                                      >
                                        Edit
                                      </UploadButton>
                                    ) : null}
                                  </div>
                                )}

                                <div className={classes.appValue2}>
                                  {(data?.stampStatus == "P" ||
                                    data?.stampStatus == "C") &&
                                    !data?.immigrationFileId && (
                                      <>
                                        <UploadButton
                                          size="small"
                                          title={"อัปโหลด*"}
                                          id={"uploadimmigrationFileId" + i}
                                          style={{
                                            width: "150px",
                                            height: "auto",
                                            borderColor: "#ED1C24",
                                            color: "#ED1C24",
                                          }}
                                          onChange={async (event) => {
                                            showAdminLoading();
                                            const response =
                                              await FileService.uploadFile({
                                                file: event.target.files[0],
                                                FileID: null,
                                                Status: true,
                                              });

                                            const fileId =
                                              response.results?.fileID;

                                            const res =
                                              await AppointmentService.userStampUploadRequest(
                                                {
                                                  draftId: x?.draftId,
                                                  immigrationFileId: fileId,
                                                  stampFileId:
                                                    data?.stampFileId,
                                                  workPermitFileId:
                                                    data?.workPermitFileId,
                                                }
                                              );

                                            if (res.status) {
                                              await getAppointment();
                                              hideAdminLoading();
                                              showAlert({
                                                type: ALERT_TYPE.SUCCESS,
                                                title: "Upload complete",
                                                description:
                                                  "You have been uploaded document successfully.",
                                                button: [
                                                  {
                                                    title: "Done",
                                                    onClick: () => {
                                                      hideAlert();
                                                    },
                                                  },
                                                ],
                                              });
                                            }
                                          }}
                                        />
                                        <div
                                          style={{
                                            color: "rgb(95, 95, 95)",
                                            fontSize: "10px",
                                            marginTop: "5px",
                                          }}
                                        >
                                          File Upload ( PDF, JPG )
                                        </div>
                                      </>
                                    )}

                                  {/* {console.log(stampDetail)} */}
                                  {(data?.stampStatus == "P" ||
                                    data?.stampStatus == "C") &&
                                    data?.immigrationFileId && (
                                      <>
                                        <div
                                          style={{
                                            cursor: "pointer",
                                            display: "flex",
                                          }}
                                          onClick={() => {
                                            openFileById(
                                              data?.immigrationFileId
                                            );
                                          }}
                                        >
                                          <div style={{ marginRight: 30 }}>
                                            <img src={"/assets/pdf.svg"} />
                                          </div>

                                          <div
                                            style={{
                                              color: "rgb(23, 43, 77)",
                                              fontWeight: "bold",
                                              fontSize: "15px",
                                              textDecoration: "underline",
                                            }}
                                          >
                                            {/* {stampDetail?.immigrationFileName}{" "}
               {stampDetail?.immigrationFileExt} */}
                                          </div>
                                        </div>
                                      </>
                                    )}
                                </div>
                              </div>
                            </div>

                            {(stampDetail?.stampStatus == "P" ||
                              stampDetail?.stampStatus == "C") &&
                              !stampDetail?.stampFileId && (
                                <div className={classes.requiredDoc}>
                                  <span>กรุณาอัปโหลดเอกสาร</span>
                                </div>
                              )}
                          </Grid>
                          <div style={{ marginTop: 5 }}>
                            <center>
                              {docDetail?.statusProcessId ==
                                STATUS_PROCESS.Complete &&
                                data?.stampFileId && (
                                  <div
                                    className={classes.appointmentDate2}
                                    style={{
                                      marginRight: 15,
                                      cursor: "pointer",
                                    }}
                                    onClick={async () => {
                                      const body = {
                                        draftId: data?.draftId,
                                      };
                                      // const blob = await AppointmentService.getReportBenefits(
                                      //   body
                                      // );
                                      const blob =
                                        await AppointmentService.getReportNotifyThai(
                                          body
                                        );

                                      const blobFile = new File(
                                        [blob],
                                        "benefits.pdf",
                                        {
                                          type: mime.getType(".pdf"),
                                        }
                                      );

                                      window.open(
                                        URL.createObjectURL(
                                          blobFile,
                                          "benefits.pdf"
                                        ),
                                        "_blank"
                                      );
                                    }}
                                  >
                                    <div
                                      className={classes.wrapAppointmentDate}
                                    >
                                      <PrintIcon style={{ marginRight: 10 }} />
                                      <span>พิมพ์แจ้งสิทธิ์</span>
                                    </div>
                                  </div>
                                )}
                              {docDetail?.statusProcessId ==
                                STATUS_PROCESS.Complete &&
                                data?.stampFileId && (
                                  <div
                                    className={classes.appointmentDate2}
                                    style={{
                                      marginRight: 15,
                                      cursor: "pointer",
                                    }}
                                    onClick={async () => {
                                      const body = {
                                        draftId: data?.draftId,
                                      };
                                      const blob =
                                        await AppointmentService.getReportNotifyEng(
                                          body
                                        );

                                      const blobFile = new File(
                                        [blob],
                                        "benefits.pdf",
                                        {
                                          type: mime.getType(".pdf"),
                                        }
                                      );

                                      window.open(
                                        URL.createObjectURL(
                                          blobFile,
                                          "benefits.pdf"
                                        ),
                                        "_blank"
                                      );
                                    }}
                                  >
                                    <div
                                      className={classes.wrapAppointmentDate}
                                    >
                                      <PrintIcon style={{ marginRight: 10 }} />
                                      <span>Print Report Benefits</span>
                                    </div>
                                  </div>
                                )}
                            </center>
                          </div>
                        </Grid>
                      </>
                    ))}
                  </Grid>
                </div>
              </>
            ))}

            <div
              className={classes.wrapDocDetail}
              style={{ paddingBottom: "40px", textAlign: "center" }}
            >
              {
                (stampDetail?.stampStatus == "P" ||
                  stampDetail?.stampStatus == "C") && (
                  <>
                    <div
                      className={classes.appointmentDate2}
                      style={{
                        marginRight: 15,
                        cursor: "pointer",
                        backgroundColor: "#ed1c24",
                      }}
                      onClick={async () => {
                        // setOpen(true);
                        submitCancel(stampDetail?.personalId);
                      }}
                    >
                      <div className={classes.wrapAppointmentDate}>
                        <BlockIcon style={{ marginRight: 10 }} />
                        <span>ยกเลิกสิทธิ์ผู้แทน</span>
                      </div>
                    </div>
                  </>
                )
                // </ColorButton>
              }

              {/* {
                stampDetail &&
                stampDetail?.stampFileId &&
                docDetail?.statusProcessId == STATUS_PROCESS.VisaReceived &&

                <span>
                  รอเจ้าหน้าที่ตรวจสอบ
                </span>

              } */}
            </div>
          </TabPanel>
        )}
      </div>
    </Paper>
  );
}
export default withLayout(AppointmentTab);

function ChangeUserPass(props) {
  const defaultInputs = {
    username: "",
    password: "",
  };
  const classes = useStyles();
  const { onClose, open } = props;
  const [input, setInput] = useState(defaultInputs);

  const handleClose = () => {
    onClose();
  };

  const handleSave = async () => {
    onClose({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInput({
      ...input,
      [name]: value,
    });
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth={true}
      maxWidth="xs"
      className={classes.warpDialog}
    >
      <DialogTitle id="simple-dialog-title">
        <div style={{ color: "#40B8D4", fontSize: 26, textAlign: "center" }}>
          Alert
        </div>
      </DialogTitle>
      <DialogContent>
        {/* <div >
          
        </div> */}
        <div>
          <label>{props?.msg}</label>
        </div>
        <div></div>

        <div className={classes.warpButtonDialogSave} style={{ marginTop: 15 }}>
          <Button
            variant="outlined"
            size="medium"
            color="primary"
            onClick={() => handleClose()}
            className={classes.buttonDialogSave}
          >
            OK
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

function DocumentUpload(props) {
  const classes = useStyles();
  const { onClose, open } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth={true}
      maxWidth="xs"
      className={classes.warpDialog}
    >
      <DialogTitle id="simple-dialog-title">
        <div style={{ color: "#40B8D4", fontSize: 26, textAlign: "center" }}>
          กรุณาอัปโหลดเอกสาร
        </div>
      </DialogTitle>
      <DialogContent>
        <div>
          <label style={{ color: "rgba(237, 28, 36, 0.8)" }}>
            กรุณาอัปโหลดเอกสารใบประทับตราและใบขาเข้า เพื่อรับใบแจ้งสิทธิ์
          </label>
        </div>
        <div></div>

        <div className={classes.warpButtonDialogSave} style={{ marginTop: 15 }}>
          <Button
            variant="outlined"
            size="medium"
            color="primary"
            onClick={() => handleClose()}
            className={classes.buttonDialogSave}
          >
            OK
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
